import axios from 'axios'

import {
  FetchEnergyContractRequest,
  FetchEnergyContractResponse,
} from '../model/energyContract.model'

import { getToken } from '~/net'

class EnergyContractService {
  constructor(private apiGateway: string) {}

  public async fetchEnergyContract(
    fetchEnergyContractRequest: FetchEnergyContractRequest,
  ): Promise<FetchEnergyContractResponse> {
    const { brand, documentId, sub } = fetchEnergyContractRequest
    return getToken().then((token) => {
      let authHeaders = {}

      if (token?.access_token !== 'NO_TOKEN_MOCK') {
        authHeaders = { authorization: `Bearer ${token.access_token}` }
      }
      const body = { document: documentId }
      return axios
        .post<FetchEnergyContractResponse>(
          `${this.apiGateway}/customers/v7/orgs/${brand}/customers/contracts/energy/search`,
          body,
          {
            headers: {
              'x-sfid': sub,
              ...authHeaders,
            },
          },
        )
        .then((result) => result.data)
    })
  }
}

export default EnergyContractService
